import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface TransferEventArgs {
  
  file?: File;
  progress?: number;
  status?: string;
  path?: string;
  
}

class TransferEvent extends EventData<Transferable> implements TransferEventArgs {

  file?: File;
  progress?: number;
  status?: string;
  path?: string;

  constructor({ file, progress, status, path  }: TransferEventArgs = {}) {
    super();

    this.file = file;
    this.progress = progress;
    this.status = status;
    this.path = path;
  }
}

class TransferEventListener extends EventListener<Transferable, TransferEvent, TransferEventArgs> {

  constructor() {
    super(TransferEvent);
  }

}

export default interface Transferable extends Mountable {

  /** @event */
  onUpload: TransferEventListener;

  /** @event */
  onRetry: TransferEventListener;

  /** @event */
  onPreview: TransferEventListener;

  /** @event */
  onRemove: TransferEventListener;

  /** @event */
  onAbort: TransferEventListener;

  /** @event */
  onError: TransferEventListener;

  /** @event */
  onCompleted: TransferEventListener;

}

export { TransferEventListener, TransferEvent };
